import { styled, Tooltip, tooltipClasses } from "@mui/material";
import styles from "./battrystatuses.module.css";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { DashCardLoader } from "../../../../../components/LoaderC";

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
    },
}));

const addOrdinalSuffix = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

const BattryStatuses = ({ selectedProperty }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [noData, setNoData] = useState(true);
    const [statusList, setStatusList] = useState([]);
    const [contentLoading, setContentLoading] = useState(true);
    const [lockBatteryStatus, setLockBatteryStatus] = useState([]);

    useEffect(() => {
        const fetchData = async (pId) => {
            setContentLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            if (pId > 0) {
                await axios.get(process.env.REACT_APP_USER_API_URL + "v1/dashboard/get-device-battery-status/" + pId, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {
                    setContentLoading(false);
                    setLockBatteryStatus(response.data.data);
                }).catch((error) => {
                    setContentLoading(false);
                    setLockBatteryStatus([]);
                });
            } else {
                setLockBatteryStatus([]);
                setContentLoading(false);
            }
        }

        if (selectedProperty > 0) {
            fetchData(selectedProperty);
        } else {
            fetchData(0);
        }
    }, [selectedProperty, getAccessTokenSilently]);

    useEffect(() => {
        if (lockBatteryStatus?.length > 0) {
            let vehicleReduce = (lockBatteryStatus, key) =>
                Object.values(lockBatteryStatus.reduce((acc, status) => {
                    let value = status[key];
                    acc[value] = acc[value] || { text: '', statuses: [] };
                    acc[value].text = value === 1 ? 'Ground Floor' : addOrdinalSuffix(value - 1) + ' Floor';
                    acc[value].statuses.push(status);

                    return acc;
                }, {}));

            setStatusList(vehicleReduce(lockBatteryStatus, 'floor'));

            let isNoData = true;
            lockBatteryStatus?.map(i => {
                if (i?.electric_quantity) {
                    isNoData = false;
                }

                return null;
            })
            setNoData(isNoData);
        } else {
            setNoData(true);
            setStatusList([]);
        }
    }, [lockBatteryStatus]);

    return <div className={`${styles.IconCardDiv}`}>
        <div className={`${styles.IconCardFullDiv}`}>
            <div className={`${styles.IfnoCardTwo}`}>
                <div className={`${styles.InsideCard}`}>
                    {contentLoading && (<div className={`${styles.LoaderDash2}`}>
                        <DashCardLoader />
                    </div>)}

                    {!contentLoading && (<>
                        <div className={`${styles.BatteryHead}`}>
                            <h6 className={`${styles.BatteryCardTitle}`}>Battery Status</h6>
                        </div>
                        {!noData && (<>
                            {statusList?.reverse()?.map((item, index) => {
                                return (<div className={`${styles.BatteryChartRow}`}>
                                    <p className={`${styles.BetteryChartTitle}`}>{item?.text}</p>
                                    <div className={`${styles.BetteryChartSec}`}>
                                        {item?.statuses?.map((subItem, subIndex) => {
                                            let classes = '';
                                            let noOfSpan = 5;
                                            if (subItem?.electric_quantity) {
                                                if (subItem?.electric_quantity > 20) {
                                                    classes = `${styles.Green}`;
                                                } else if (subItem?.electric_quantity > 10) {
                                                    classes = `${styles.Orange}`;
                                                } else {
                                                    classes = `${styles.Red}`;
                                                }
                                                if (subItem?.electric_quantity > 80) {
                                                    noOfSpan = 5;
                                                } else if (subItem?.electric_quantity > 60) {
                                                    noOfSpan = 4;
                                                } else if (subItem?.electric_quantity > 40) {
                                                    noOfSpan = 3;
                                                } else if (subItem?.electric_quantity > 20) {
                                                    noOfSpan = 2;
                                                } else {
                                                    noOfSpan = 1;
                                                }

                                            }

                                            return (<div className={`${styles.BetteryCount} ${classes}`}>
                                                <BootstrapTooltip title={subItem?.electric_quantity ? <><div>{subItem?.apt_no}</div><div>Battery {subItem?.electric_quantity}%</div></> : null}>
                                                    <div className={`${styles.BetteryCountUnder}`}>
                                                        <span></span>
                                                        {noOfSpan >= 2 && <span></span>}
                                                        {noOfSpan >= 3 && <span></span>}
                                                        {noOfSpan >= 4 && <span></span>}
                                                        {noOfSpan >= 5 && <span></span>}
                                                        <p>{subItem?.apt_no.replace("Unit ", "")}</p>
                                                    </div>
                                                </BootstrapTooltip>
                                            </div>)
                                        })}
                                    </div>
                                </div>);
                            })}
                        </>)}
                        {noData && (<div className={`${styles.NoDataSec}`}>
                            <div className={`${styles.NoDataIMG}`}><img src="/static/img/no-battery.png" alt="" /></div>
                            <p className={`${styles.NoDataText}`}>Oops!</p>
                            <p className={`${styles.NoDataTextSub}`}>Battery Not Detected.</p>
                        </div>)}
                    </>)}
                </div>
            </div>
        </div>
    </div>;
}

export default BattryStatuses;